import { AssetCommentService as OvermapAssetCommentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class AssetCommentService extends OvermapAssetCommentService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
